import { render, staticRenderFns } from "./ModalEditSearchTerm.vue?vue&type=template&id=1ddd17be"
import script from "./ModalEditSearchTerm.vue?vue&type=script&lang=js"
export * from "./ModalEditSearchTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports